export default "__VITE_ASSET__GZzx8AYV__"